import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import EngagementService from "../../Services/Engagement.service";
import ReportService from "../../Services/Report.service";
import useService from "../Hooks/useService";
import KeyEngagementScoresByPersonWidget from "../Presentational/Widgets/KeyEngagementScoresByPersonWidget";
const PAGE_SIZE = 10;
const KeyEngagementScoresByPersonContainer = () => {
    const loadReportPermissions = useService(ReportService.getAccessibleReports)[1];
    const [modalFilterState, loadModalFilterState] = useService(EngagementService.getTeamEngagementModalFilter);
    const saveModalFilter = useService(EngagementService.setTeamEngagementModalFilter)[1];
    const [performancesState, loadPerformancesState] = useService(EngagementService.getKeyEngagementPerformance);
    const [hasAccessToKeyEngagementsReport, setHasAccessToKeyEngagementsReport] = React.useState(false);
    const [filterSettings, setFilterSettings] = React.useState({
        lastKeyEngagementMaxDaysAgo: 30,
        registrationTerms: [],
        teams: [],
    });
    const [modalFilterSettings, setModalFilterSettings] = React.useState({
        lastKeyEngagementMaxDaysAgo: 30,
        registrationTerms: [],
        teams: [],
    });
    const [sortField, setSortField] = React.useState("name");
    const [order, setOrder] = React.useState("asc");
    const [pageIndex, setPageIndex] = React.useState(0);
    const hasNextPage = React.useMemo(() => {
        return performancesState.data
            ? performancesState.data.length > PAGE_SIZE
            : false;
    }, [performancesState]);
    const hasPrevPage = React.useMemo(() => {
        return pageIndex > 0;
    }, [pageIndex]);
    const nextPage = () => {
        setPageIndex((prevIndex) => prevIndex + 1);
    };
    const prevPage = () => {
        setPageIndex((prevIndex) => prevIndex - 1);
    };
    const isFiltered = React.useMemo(() => !!((filterSettings.teams && filterSettings.teams.length) ||
        (filterSettings.registrationTerms &&
            filterSettings.registrationTerms.length)), [filterSettings]);
    React.useEffect(() => {
        loadReportPermissions().then((result) => {
            if (result.find((el) => el.internalName === "Engagement")) {
                setHasAccessToKeyEngagementsReport(true);
            }
        });
        loadModalFilterState().then((result) => {
            setFilterSettings(EngagementService.getFilterSettingsFromRaw(result, true));
        });
    }, [loadModalFilterState, loadReportPermissions]);
    React.useEffect(() => {
        if (modalFilterState.wasSuccessful && modalFilterState.data) {
            const settings = EngagementService.getFilterSettingsFromRaw(modalFilterState.data, true);
            loadPerformancesState({
                lastKeyEngagementMaxAgeDaysAgo: settings.lastKeyEngagementMaxDaysAgo,
                teamIds: settings.teams
                    ? settings.teams.map((team) => (team.id ? team.id : ""))
                    : [],
                registrationTermIds: settings.registrationTerms.map((term) => term.id),
                offset: pageIndex * PAGE_SIZE,
                max: PAGE_SIZE + 1,
                sortType: sortField,
                order,
            });
        }
    }, [
        pageIndex,
        sortField,
        order,
        loadPerformancesState,
        modalFilterState.data,
        modalFilterState.wasSuccessful,
    ]);
    React.useEffect(() => {
        setModalFilterSettings(Object.assign({}, filterSettings));
    }, [filterSettings]);
    const saveModalFilterSettings = (settings) => {
        saveModalFilter({
            daysAgo: settings.lastKeyEngagementMaxDaysAgo,
            teamIds: settings.teams
                ? settings.teams.map((team) => (team.id ? team.id : ""))
                : [],
            registrationTermIds: settings.registrationTerms.map((term) => term.id),
        }).then((result) => {
            setFilterSettings(EngagementService.getFilterSettingsFromRaw(result.attributes, true));
        });
        loadPerformancesState({
            lastKeyEngagementMaxAgeDaysAgo: settings.lastKeyEngagementMaxDaysAgo,
            teamIds: settings.teams
                ? settings.teams.map((team) => (team.id ? team.id : ""))
                : [],
            registrationTermIds: settings.registrationTerms.map((term) => term.id),
            offset: pageIndex * PAGE_SIZE,
            max: PAGE_SIZE + 1,
            sortType: sortField,
            order,
        });
    };
    return (_jsx(KeyEngagementScoresByPersonWidget, { isFiltered: isFiltered, filterSettings: filterSettings, setFilterSettings: setFilterSettings, modalFilterSettings: modalFilterSettings, setModalFilterSettings: setModalFilterSettings, saveModalFilterSettings: saveModalFilterSettings, sortField: sortField, setSortField: setSortField, order: order, setOrder: setOrder, prevPage: prevPage, nextPage: nextPage, hasNextPage: hasNextPage, hasPrevPage: hasPrevPage, hasAccessToKeyEngagementsReport: hasAccessToKeyEngagementsReport, performancesState: performancesState, pageSize: PAGE_SIZE }));
};
export default KeyEngagementScoresByPersonContainer;
